import AjaxPromises from '../utils/AjaxPromises';

import { endPoints as EndPoints } from '../constants/HypurConstants';

export default {

    loadCheckedInClients:(formData) => {
        return AjaxPromises.POST(EndPoints.GET_CHECKED_IN_CLIENTS, formData);
    }
}



// WEBPACK FOOTER //
// ./ui_src/app/api/HypurApi.jsx